// Verified and translated against the user-supplied benefits chart on 2026-09-22.
// English source labels are retained for review, never rendered in the page.
export const PAGE_TITLE = 'Jumeirah One会员礼遇';
export const introduction = '在Jumeirah One会员旅程中，从普通会员晋升至白金卡，累积更多积分，尊享更多专属礼遇。';
export const tiers = ['会员', '银卡', '金卡', '白金卡'];

export const benefitGroups = [
  {
    id: 'qualification', title: '', accessibleTitle: '会籍升级条件',
    rows: [
      {
        id: 'annual-spend', source: 'Spend Requirement Per Membership Year (USD)',
        title: '每个会籍年度的消费要求（美元）',
        values: ['0', '2,500', '15,000', '45,000']
      },
      {
        id: 'tier-points', source: 'Tier Points', title: '会籍等级积分',
        values: ['0 - 4,999', '5,000 - 29,999', '30,000 - 89,999', '高于90,000']
      }
    ]
  },
  {
    id: 'programme', source: 'Programme Benefits', title: '会籍计划礼遇',
    rows: [
      {
        id: 'bonus-points', source: 'Bonus Jumeirah One Points', title: '额外会员积分',
        values: [false, '25%', '50%', '100%']
      },
      {
        id: 'fifth-night', source: 'Complimentary 5th Redemption Night',
        title: '积分兑换住宿，第五晚免费', values: [false, false, true, true]
      },
      {
        id: 'companion', source: 'Complimentary membership for companion',
        title: '免费赠予同行人会籍', values: [false, false, '银卡', '金卡']
      }
    ]
  },
  {
    id: 'stay', source: 'Stay benefits', title: '住宿礼遇',
    rows: [
      {
        id: 'member-rates', source: 'Member-only rates', title: '会员专享房价',
        values: [true, true, true, true]
      },
      {
        id: 'breakfast', source: 'Complimentary breakfast (member plus one guest sharing a room)',
        title: '免费早餐（会员及一位同住宾客）', values: [false, true, true, true]
      },
      {
        id: 'welcome', source: 'Welcome amenity', title: '迎宾礼遇',
        values: [false, true, true, true]
      },
      {
        id: 'invitation-return', source: 'An Invitation to Return',
        title: '再次莅临邀请', values: [true, false, false, false]
      },
      {
        id: 'late-checkout', source: 'Late check-out (subject to availability)',
        title: '延迟退房（视供应情况而定）', values: [false, '下午2点', '下午4点', '下午4点']
      },
      {
        id: 'minibar', source: 'Daily free mini bar (soft drinks)',
        title: '每日免费迷你吧（软饮）', values: [false, false, true, true]
      },
      {
        id: 'airport', source: 'Airport Transfer (minimum four consecutive nights required)',
        title: '机场接送（至少连续入住4晚）', values: [false, false, '单程', '往返']
      },
      {
        id: 'pressing', source: 'Complimentary pressing (2 items/stay)',
        title: '免费熨烫（每次入住2件衣物）', values: [false, false, true, true]
      },
      {
        id: 'guaranteed-room', source: 'Guaranteed room availability (48hrs prior to arrival)',
        title: '客房供应保证（抵达前48小时）', values: [false, false, false, '48小时']
      },
      {
        id: 'early-checkin', source: 'Early check-in (subject to availability)',
        title: '提前入住（视供应情况而定）', values: [false, false, false, '上午9点']
      },
      {
        id: 'in-room-checkin', source: 'In-room check-in', title: '客房内办理入住',
        values: [false, false, false, true]
      },
      {
        id: 'preferred-room', source: 'Preferred room selection (subject to availability, upon check-in)',
        title: '按偏好选择客房（办理入住时视供应情况而定）', values: [false, false, false, true]
      },
      {
        id: 'upgrade', source: 'Upgrade to Next Room Category Excluding Suites and Villas (subject to availability)',
        title: '升级至高一级房型（不含套房及别墅，视供应情况而定）', values: [false, false, false, true]
      }
    ]
  },
  {
    id: 'dining', source: 'Dining benefits', title: '餐饮礼遇',
    rows: [
      {
        id: 'dining-savings', source: 'Savings at Jumeirah restaurants in UAE hotels',
        title: '阿联酋境内卓美亚酒店餐厅优惠', values: [false, '10%', '10%', '15%'],
        description: '表内百分比表示可节省的费用比例。'
      },
      {
        id: 'restaurant-priority', source: 'Priority restaurant reservations',
        title: '餐厅优先预订', values: [false, false, true, true]
      },
      {
        id: 'chef-welcome', source: "Chef's Welcome", title: '主厨欢迎礼遇',
        values: [false, false, true, false]
      },
      {
        id: 'meet-chef', source: 'Meet the Chef Experience (when staying)',
        title: '入住期间与主厨见面体验', values: [false, false, false, true]
      },
      {
        id: 'preferred-table', source: 'Preferred Table Choice (to be requested 24hrs prior to arrival)',
        title: '按偏好选择餐桌（须在抵达前24小时提出申请）', values: [false, false, false, true]
      },
      {
        id: 'kids-dining', source: 'Complimentary Dining for up to Two Kids (below 12 years)',
        title: '最多两名未满12周岁儿童免费用餐', values: [false, false, false, true]
      }
    ]
  },
  {
    id: 'lifestyle', source: 'Lifestyle & Entertainment Benefits', title: '生活方式与娱乐礼遇',
    rows: [
      {
        id: 'spa', source: 'Savings on spa treatments', title: '水疗护理优惠',
        values: ['10%', '10%', '20%', '20%'],
        description: '表内百分比表示可节省的护理费用比例。'
      }
    ]
  }
];
